import { jsx as n } from "react/jsx-runtime";
import l from "react";
import a from "react-fast-compare";
import { MenuColumnTheme as s } from "../../interfaces.js";
import f from "../NavItem/NavItem.js";
import { MenuColumn as d } from "./styled.js";
const p = ({
  activeId: m,
  items: o = [],
  onSelect: u,
  colorScheme: t = s.DARK_GREY,
  colNum: i
}) => {
  const c = o.length > 0;
  return /* @__PURE__ */ n(d, { $isActive: c, $colorScheme: t, children: o.map((e, r) => /* @__PURE__ */ n(
    f,
    {
      colNum: i,
      rowNum: r,
      isActive: m === e.id,
      item: e,
      onSelect: () => u(r),
      $colorScheme: t
    },
    e.id
  )) });
}, I = l.memo(p, (m, o) => a(m.items, o.items) && m.activeId === o.activeId);
export {
  I as default
};
